import { useCallback, useEffect, useMemo } from 'react';
import { gql, useMutation } from '@apollo/client';
import { useLocation } from '@gatsbyjs/reach-router';
import {
  ascFormSubmissionSales,
  ascFormSubmissionSalesAppt,
  getGaSessionId,
} from 'helpers/src/gtag';

const CREATE_SUBMISSION = gql`
  mutation($input: createSubmissionInput) {
    createSubmission(input: $input) {
      submission {
        id
        name
      }
    }
  }
`;

const useCreateSubmission = (
  formValues,
  name,
  id,
  { ctaText } = {},
) => {
  const { origin, href } = useLocation();
  const [createLead, { data, loading, error }] = useMutation(CREATE_SUBMISSION);
  const gaSessionId = useMemo(() => getGaSessionId(), []);
  const onSubmit = useCallback(async (e) => {
    e.preventDefault();
    try {
      await createLead({
        variables: {
          input: {
            data: {
              form: id,
              fields: {
                ...formValues,
                ...(gaSessionId ? { gaSessionId } : {}),
              },
              source: origin,
              url: href,
            },
          },
        },
      });
    } catch (err) {
      if (typeof Sentry === 'undefined') {
        console.warn('There is no Sentry, not sending...');
        return;
      }
      Sentry.captureException(err, (scope) => {
        scope.clear();
        scope.setContext('form', { name, href });
        scope.setContext('fields', formValues);
        return scope;
      });
    }
  }, [createLead, id, formValues, gaSessionId, origin, href, name]);

  useEffect(() => {
    if (data) {
      const lead = data.createSubmission.submission;
      const isAppt = false; // @TODO implement based on a form setting
      const fn = isAppt ? ascFormSubmissionSalesAppt : ascFormSubmissionSales;
      let comm_outcome = 'crm_update';
      // we assume updates are always specific deals
      if (isAppt) {
        comm_outcome = 'send_appt';
      }
      fn({
        // event_owner,
        // page_type,
        comm_type: 'form',
        comm_outcome,
        submission_id: lead?.id,
        element_text: ctaText,
        department: 'sales',
        form_name: name,
        form_type: 'consumer_contact',
      });
    }
  }, [data, name, ctaText]);

  return {
    onSubmit,
    data,
    loading,
    error,
  };
};

export default useCreateSubmission;
